import { defineElement, StyledElement } from '@webtides/element-js';
import style from './filter-overview.css';

export default class FilterOverview extends StyledElement {
    /** @type {NodeListOf<HTMLElement>} */
    filterSections;

    constructor() {
        super({ styles: [style] });
    }

    connected() {
        this.filterSections = this.querySelectorAll('[data-filter-category]');
    }

    events() {
        return {
            'mb-filter-tags': {
                'mb-filter-change': (event) => {
                    const selectedCategories = event.detail;
                    for (const section of this.filterSections) {
                        const sectionCategories = section.dataset.filterCategory.split(',').map((c) => c.trim());
                        const visible =
                            selectedCategories.length === 0 ||
                            selectedCategories.some((cat) => sectionCategories.includes(cat));
                        section.style.display = visible ? '' : 'none';
                    }
                },
            },
        };
    }
}

defineElement('mb-filter-overview', FilterOverview);
